import request from './request'

// 封装GET请求
export const get = (url, params) => {
  // 获取token
  const token = localStorage.getItem('token')
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {}
  
  return request({
    url,
    method: 'get',
    params,
    headers
  })
}

// 封装POST请求
export const post = (url, data) => {
  // 获取token
  const token = localStorage.getItem('token')
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {}

  return request({
    url,
    method: 'post',
    data,
    headers
  })
}

// 可选：如果需要put和delete方法，可以类似实现
export const put = (url, data) => {
  const token = localStorage.getItem('token')
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {}

  return request({
    url,
    method: 'put',
    data,
    headers
  })
}

export const del = (url, data) => {
  const token = localStorage.getItem('token')
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {}

  return request({
    url,
    method: 'delete',
    data,
    headers
  })
}

// 导出文件请求 - 返回二进制数据
export const exportFile = (url, data) => {
  const token = localStorage.getItem('token')
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {}

  return request({
    url,
    method: 'post',
    data,
    headers,
    responseType: 'blob'
  })
}
